import { useState, useEffect } from 'react';
import { getDiscipleTypes } from '../apis/disciple-apis';
import { DiscipleType } from '../types/disciple';

// 기본 선택 옵션 (첫 번째 옵션)
const DEFAULT_DISCIPLE_TYPE: DiscipleType = {
  id: 0,
  department: '',
  displayName: '선택해주세요',
  description: '',
};

// 모듈 레벨 캐시: 여러 컴포넌트에서 사용해도 한 번만 API 호출
let cachedDiscipleTypes: DiscipleType[] | null = null;
let loadingPromise: Promise<DiscipleType[]> | null = null;

/**
 * 제자종류 옵션을 DB에서 가져오는 커스텀 훅
 * 여러 컴포넌트에서 사용하더라도 한 번만 API를 호출하고 모듈 레벨에서 캐싱함
 */
export const useDiscipleTypes = () => {
  const [discipleTypes, setDiscipleTypes] = useState<DiscipleType[]>(cachedDiscipleTypes || [DEFAULT_DISCIPLE_TYPE]);
  const [loading, setLoading] = useState(!cachedDiscipleTypes);

  useEffect(() => {
    // 이미 캐시된 데이터가 있으면 즉시 반환
    if (cachedDiscipleTypes) {
      setDiscipleTypes(cachedDiscipleTypes);
      setLoading(false);
      return;
    }

    // 로딩 전에도 기본 옵션만이라도 표시
    setDiscipleTypes([DEFAULT_DISCIPLE_TYPE]);

    // 이미 로딩 중이면 기존 Promise 재사용
    if (loadingPromise) {
      loadingPromise.then((types) => {
        setDiscipleTypes(types);
        setLoading(false);
      });
      return;
    }

    // 첫 호출 시 API 호출
    loadingPromise = getDiscipleTypes()
      .then((types) => {
        // 기본 옵션을 맨 앞에 추가
        cachedDiscipleTypes = [DEFAULT_DISCIPLE_TYPE, ...types];
        setDiscipleTypes([DEFAULT_DISCIPLE_TYPE, ...types]);
        setLoading(false);
        return [DEFAULT_DISCIPLE_TYPE, ...types];
      })
      .catch((error) => {
        console.error('제자종류 로딩 실패:', error);
        setLoading(false);
        loadingPromise = null; // 실패 시 재시도 가능하도록
        throw error;
      });
  }, []);

  return { discipleTypes, loading };
};
